var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btnClose") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,40 C26.5353674,40 32.3386035,36.8653735 35.9882325,32.0175964 C38.5069926,28.6719447 40,24.5103276 40,20 C40,8.954305 31.045695,0 20,0 C8.954305,0 0,8.954305 0,20 C0,31.045695 8.954305,40 20,40 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/floating-close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btnClose"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bgClose",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#222526",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222526",
    strokeWidth: 2,
    d: "M20,39 C26.0472465,39 31.6202704,36.1568931 35.1893251,31.4161423 C37.6489836,28.1489949 39,24.1781908 39,20 C39,9.50658975 30.4934102,1 20,1 C9.50658975,1 1,9.50658975 1,20 C1,30.4934102 9.50658975,39 20,39 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "X",
    fill: "#FFFFFF",
    points: "27 14.4 25.6 13 20 18.6 14.4 13 13 14.4 18.6 20 13 25.6 14.4 27 20 21.4 25.6 27 27 25.6 21.4 20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.aee19044b3e4fe802b546843db93c991.svg";
export { ForwardRef as ReactComponent };